module.exports = __webpack_public_path__ + "img/contacts-slim.27ef5c53.svg";